// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__3dk8P","formSpace":"styles_formSpace__uMOJq","actionButton":"styles_actionButton__3oqLu","actionIcon":"styles_actionIcon__5q2KH"};